<div [ngClass]="customWidth || customHeight ? '' : dialogSize"
     [style.width]="customWidth"
     [style.height]="customHeight"
     class="flex flex-col">
  <div class="flex justify-between items-center px-4 header-band">
    <div>{{ toolbarTitle }}</div>
    <button
      *ngIf="!hard"
      type="button"
      class="close-button"
      aria-label="Close dialog"
      (click)="buttonClick('dismiss')"
    >
      <lib-cdw-icon class="close-icon" icon="close"></lib-cdw-icon>
    </button>
  </div>
  <div class="flex grow content-area w-full">
    <ng-content></ng-content>
  </div>
  <div [ngClass]="buttonAlignment" class="flex gap-4 button-area">
    <lib-cdw-button
      *ngIf="secondaryButtonText"
      (buttonClick)="buttonClick('secondary')"
      level="secondary"
      mode="standard"
      [disabled]="secondaryButtonDisabled"
      >{{ secondaryButtonText }}</lib-cdw-button
    >
    <lib-cdw-button
      (buttonClick)="buttonClick('primary')"
      level="primary"
      [mode]="buttonAlignment === 'justify-end' ? 'standard' : 'small'"
      [disabled]="primaryButtonDisabled"
      >{{ primaryButtonText }}</lib-cdw-button
    >
  </div>
</div>
